import { useAtomValue } from "jotai";
import Script from "next/script";
import type { FunctionComponent } from "react";

import { googleFundingChoicesAtom } from "~/components/advertisement/funding-choices/atoms";
import { config } from "~/data";

export const MagniteDemandManagerScripts: FunctionComponent = () => {
  const { isReady: isFundingChoiceReady } = useAtomValue(googleFundingChoicesAtom);
  if (!isFundingChoiceReady) return null;

  return (
    <Script
      id="magnite-demand-manager-script"
      src={config.advertisement.magniteDemandManger.scriptUrl}
      strategy="lazyOnload"
    />
  );
};

MagniteDemandManagerScripts.displayName = "MagniteDemandManagerScripts";
